module.exports = __webpack_public_path__ + "img/kp-bt.9ebf4145.png";